import {
  Integration,
  IntegrationJob,
  getIntegrationJobs as apiGetIntegrationJobs,
} from 'api/orgAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch } from '../..';

// Types

export type Integrations = {
  jazzhr?: {
    isFetching: boolean;
    jobs?: Array<IntegrationJob> | null | undefined;
  };
  greenhouse?: {
    isFetching: boolean;
    jobs?: Array<IntegrationJob> | null | undefined;
  };
};
export type State = {
  byId: Record<string, Integrations>;
};

type FetchIntegrationAction = {
  type: 'FETCH_INTEGRATION_ACTION';
  integrationType: Integration;
  orgId: string;
};
type FetchIntegrationFailureAction = {
  type: 'FETCH_INTEGRATION_FAILURE_ACTION';
  integrationType: Integration;
  orgId: string;
};
type FetchIntegrationSuccessAction = {
  type: 'FETCH_INTEGRATION_SUCCESS_ACTION';
  integrationType: Integration;
  jobs: Array<IntegrationJob> | null | undefined;
  orgId: string;
};
export type Action =
  | FetchIntegrationSuccessAction
  | FetchIntegrationAction
  | FetchIntegrationFailureAction;

// Reducer

const initialState = {
  byId: {},
};

export default function integrationsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'FETCH_INTEGRATION_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs:
          orgIntegrations && orgIntegrations[action.integrationType]
            ? orgIntegrations[action.integrationType].jobs
            : [],
        isFetching: true,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    case 'FETCH_INTEGRATION_FAILURE_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs: [],
        isFetching: false,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    case 'FETCH_INTEGRATION_SUCCESS_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs: action.jobs,
        isFetching: false,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

export const clearIntegrationJobs =
  (orgId: string, type: Integration) => (dispatch: Dispatch) => {
    dispatch({
      type: 'FETCH_INTEGRATION_SUCCESS_ACTION',
      integrationType: type,
      orgId,
      jobs: null,
    });
  };
export const fetchIntegrationJobs =
  (orgId: string, type: Integration) => (dispatch: Dispatch) => {
    dispatch({
      type: 'FETCH_INTEGRATION_ACTION',
      integrationType: type,
      orgId,
    });
    return apiGetIntegrationJobs(orgId, type)
      .then(({ jobs }) => {
        dispatch({
          type: 'FETCH_INTEGRATION_SUCCESS_ACTION',
          integrationType: type,
          orgId,
          jobs,
        });
        return jobs;
      })
      .catch((e) => {
        dispatch({
          type: 'FETCH_INTEGRATION_FAILURE_ACTION',
          integrationType: type,
          orgId,
        });
        return e;
      });
  };
